import DataMapper from './DataMapper'
import CancelledByInvestigatorList from '../../models/CancelledByInvestigatorList'
import CancelledByInvestigatorListRM from '../responsemodel/CancelledByInvestigatorList'

export default class CancelledByInvestigatorListDataMapper extends DataMapper<CancelledByInvestigatorListRM, CancelledByInvestigatorList> {
    map = (rm: CancelledByInvestigatorListRM) => { return new CancelledByInvestigatorList(rm._id, rm.reason, rm.case_state, rm.claim_number, rm.createdAt, rm.updatedAt, rm.name) }
}
